module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Files/Folder-heart-f7ac8164ee982e426dde8bea07e8a2b1.svg";